import type { ProcedureSummary } from "../queries/useProceduresQuery";

type DefaultProcedureOption = { id: string; name: string } | null | undefined;

export function getProcedureOptions(
  procedures: ProcedureSummary[] | undefined,
  defaultProcedure: DefaultProcedureOption,
): Array<Pick<ProcedureSummary, "id" | "name" | "status">> {
  const options = (procedures ?? []).map(({ id, name, status }) => ({
    id,
    name,
    status,
  }));
  if (
    defaultProcedure &&
    !options.some((procedure) => procedure.id === defaultProcedure.id)
  ) {
    options.push({ ...defaultProcedure, status: "published" });
  }
  return options;
}
